import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

const AdminSidebar = ({ activePage, setActivePage }) => {
  const { user } = useAuth();

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '📊', roles: ['admin', 'bendahara', 'pengelola'] },
    { id: 'keuangan', label: 'Keuangan', icon: '💰', roles: ['admin', 'bendahara'] },
    { id: 'produk', label: 'Produk UMKM', icon: '🛍️', roles: ['admin', 'pengelola'] },
    { id: 'informasi', label: 'Informasi', icon: '📰', roles: ['admin', 'pengelola'] },
    { id: 'laporan', label: 'Laporan', icon: '📈', roles: ['admin', 'bendahara'] },
    { id: 'pengguna', label: 'Pengguna', icon: '👥', roles: ['admin'] },
  ];

  const filteredMenu = menuItems.filter(item => 
    item.roles.includes(user?.role)
  );

  return (
    <div className="w-64 bg-blue-800 min-h-screen">
      <div className="p-6">
        <h2 className="text-white text-xl font-bold">Menu Admin</h2>
      </div>

      <nav className="mt-8">
        {filteredMenu.map((item) => (
          <button
            key={item.id}
            onClick={() => setActivePage(item.id)}
            className={`w-full flex items-center px-6 py-4 text-left transition-colors duration-200 ${
              activePage === item.id
                ? 'bg-blue-700 text-white border-r-4 border-yellow-400' 
                : 'text-blue-100 hover:bg-blue-700'
            }`}
          >
            <span className="text-lg mr-3">{item.icon}</span>
            <span className="font-medium">{item.label}</span>
          </button>
        ))}
      </nav>

      <div className="absolute bottom-0 w-64 p-4 border-t border-blue-700">
        <div className="text-center text-blue-200 text-sm">
          <p>BUMDES Desa Makmur</p>
          <p className="text-xs mt-1">© 2024 All rights reserved</p>
        </div>
      </div>
    </div>
  );
};

export default AdminSidebar;